import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBriefcase } from "@fortawesome/pro-light-svg-icons/faBriefcase";
import { faHome } from "@fortawesome/pro-light-svg-icons/faHome";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import { TripType } from "@mapmycustomers/shared/enum";
import Trip from "@mapmycustomers/shared/types/entity/Trip";

import i18nService from "@app/config/I18nService";
import getTripTypeDisplayName from "@app/util/ui/getTripTypeDisplayName";

import styles from "./TripTypeCellRenderer.module.scss";

const typeToIcon: Record<"unclassified" | TripType, IconDefinition> = {
  [TripType.BUSINESS]: faBriefcase,
  [TripType.PERSONAL]: faHome,
  unclassified: faInfoCircle,
};

const TripTypeCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const intl = i18nService.getIntl();

  if (!intl) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  const tripType = value as Trip["type"];

  return (
    <div className={styles.container}>
      <FontAwesomeIcon
        className={cn(styles.icon, {
          [styles.business]: value === TripType.BUSINESS,
          [styles.personal]: value === TripType.PERSONAL,
        })}
        icon={typeToIcon[tripType ?? "unclassified"]}
      />
      <span>{getTripTypeDisplayName(intl, tripType)}</span>
    </div>
  );
};

export default TripTypeCellRenderer;
